<div class="standard-max-width pt-4">
    <!-- Patient Details Section -->
    <div class="surface-50 border-round-lg border-200 py-2 mb-6">
        <div class="w-full flex justify-content-between align-items-center mb-4">
            <div class="flex align-items-center gap-3">
                <i class="pi pi-user text-3xl text-primary"></i>
                <div class="flex align-items-center gap-2">
                    <div>
                        <h2 class="text-3xl font-semibold text-800 m-0">Patient Details</h2>
                        <p class="text-600 m-0 text-sm">Personal information and demographics</p>
                    </div>
                    <button pButton (click)="toggleCrudPatientEditMode()"
                        [icon]="'pi' + ' ' + (crudPatientMode === CrudPatientMode.READ ? 'pi-pencil' : 'pi-times') "
                        class="p-button-text p-button-sm text-primary"
                        [severity]="crudPatientMode === CrudPatientMode.READ ? 'secondary' : 'danger'">
                    </button>
                </div>
            </div>

            <div class="flex align-items-center gap-3">
                <app-patient-actions-menu [orgId]="this.orgId" [patientId]="this.patientId"
                    (menuEvent)="onMenuEvent($event)">
                </app-patient-actions-menu>
                <button pButton (click)="calculatePremo()" label="Calculate PreMO" icon="pi pi-chart-line"
                    class="p-button-primary">
                </button>
            </div>
        </div>
        <app-crud-patient [patientId]="patientId" [orgId]="orgId" [crudMode]="crudPatientMode" [collapsible]="true" />
    </div>

    <!-- Visits Section -->
    <div class="surface-50 border-round-lg border-200 py-2 mb-5">
        <div class="w-full flex justify-content-between align-items-center mb-4">
            <div class="flex align-items-center gap-3">
                <i class="pi pi-calendar text-2xl text-blue-400"></i>
                <div>
                    <h3 class="text-2xl font-semibold text-700 m-0">Visits</h3>
                    <p class="text-600 m-0 text-sm">Patient visit history and scheduling</p>
                </div>
            </div>

            <button pButton label="Add Visit" icon="pi pi-plus" class="p-button-outlined"
                (click)="navigateToAddVisit()"></button>
        </div>
        <app-visits-view #visitsView [patientId]="patientId" [orgId]="orgId" [collapsible]="true" />
    </div>

    <!-- Treatments Section -->
    <div class="surface-50 border-round-lg border-200 py-2 mb-5">
        <div class="w-full flex justify-content-between align-items-center mb-4">
            <div class="flex align-items-center gap-3">
                <i class="pi pi-shield text-2xl text-purple-400"></i>
                <div>
                    <h3 class="text-2xl font-semibold text-700 m-0">Treatments</h3>
                    <p class="text-600 m-0 text-sm">Myopia Treatments</p>
                </div>
            </div>

            <button pButton label="Add Treatment" icon="pi pi-plus" class="p-button-outlined"
                (click)="showAddTreatment()"></button>
        </div>
        <app-treatments-view #treatmentsView [patientId]="patientId" [orgId]="orgId" [collapsible]="true" />
    </div>

    <!-- Patient Forms Section -->
    <!--div class="surface-50 border-round-lg border-200 py-2 mb-5">
        <div class="w-full flex justify-content-between align-items-center mb-4">
            <div class="flex align-items-center gap-3">
                <i class="pi pi-file-edit text-2xl text-green-400"></i>
                <div>
                    <h3 class="text-2xl font-semibold text-700 m-0">Patient Forms</h3>
                    <p class="text-600 m-0 text-sm">Form assignments and submissions</p>
                </div>
            </div>

            <button pButton label="Assign Form" icon="pi pi-plus" class="p-button-outlined"
                (click)="navigateToAssignForm()"></button>
        </div>

        <app-form-assignments [patientId]="patientId" [orgId]="orgId" [collapsible]="true" viewMode="patient" />
    </div-->
</div>

<p-dialog header="Add Treatment" [(visible)]="showTreatmentDialog" [modal]="true" [style]="{width: '35vw'}"
    [draggable]="false" [resizable]="false" [closable]="true" appendTo="body" (onHide)="showTreatmentDialog=false">

    <app-crud-treatment *ngIf="showTreatmentDialog" [orgId]="orgId" [patientId]="patientId"
        (onFormSubmit)="onTreatmentSubmit()" crudMode="create">
    </app-crud-treatment>

</p-dialog>